import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { interceptorsToken, ProfileService, UserRole } from 'library-explorer';

@Injectable()
export class ContentVisibilityInterceptor implements HttpInterceptor {

  constructor(private readonly profileService: ProfileService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const bypassContentVisibility = request.params.get(interceptorsToken.BYPASS_CONTENT_VISIBILITY);

    if (bypassContentVisibility) {
      request = request.clone({
        params: request.params.delete(interceptorsToken.BYPASS_CONTENT_VISIBILITY)
      });

      return next.handle(request);
    }

    const manageContentRoles = [UserRole.ADMIN, UserRole.CONTENT_MANAGER, UserRole.GENERAL_MANAGER];
    const profileRole = this.profileService.getCurrentProfileValue()?.role;
    const canManageContent = manageContentRoles.indexOf(profileRole) !== -1;

    if (canManageContent) {
      request = request.clone({
        params: request.params.delete('active')
      });
    }

    return next.handle(request);
  }
}
